import React from "react";
import HoverButton from "../../component/HoverButton";
import PageLayout from "../../component/PageLayout";
import ProductTallyPrimeTabs from "../../component/Product-TallyPrime";
import IconRightArrow from "../../component/SvgIcons/IconRightArrow";
import IconSvgAnimation from "../../component/SvgIcons/IconSvgAnimation";
import IconTallyPrimelogo from "../../component/SvgIcons/IconTallyPrimelogo";
import { datamap, featuresData, pricingData } from "./DataFiles";
import "./style.css";

export default function TallyPrime() {
  return (
    <div className="TallyPrimebg firsttab">      
      <PageLayout>
        <ProductTallyPrimeTabs />
        <section className="TabFirstTallyPrime-tab pt50">
          <div className="container">
            <div className="d-flex flex-column align-items-center  gap50 mb100">
              <div className="tallylogofitrsttab">
                <IconTallyPrimelogo />
              </div>
              <img
                src="../images/tallyprime/prime-page-banner-right-img.webp"
                className="img-fluid"
                alt="Tally Prime"
                width="450"
              />
              <div className="button d-flex gap50">
                <a
                  href="../images/satup/tallyprime_setup6-0.exe"
                  download
                  className="btn btn-danger"
                >
                  <label>
                    Download Now <IconRightArrow />
                  </label>{" "}
                  <span></span>
                </a>
                <HoverButton btnclassname="btn btn-dark" to="/contact">
                  <label>
                    Contact Us Now <IconRightArrow />
                  </label>
                </HoverButton>
              </div>
            </div>

            <div className="titletwo twotabintaly text-center">
              <h2>
                Manage your business, your way - <span>with TallyPrime</span>
              </h2>
            </div>

            {datamap.map((item, index) => (
              <div
                key={index}
                className={`yourgroth d-flex ${
                  item.reverse ? "flex-sm-row-reverse" : ""
                } flex-column flex-sm-row align-items-center gap50`}
              >
                <div className="yourgroth-picture">
                  <img
                    src={item.img}
                    alt={`${item.heading.replace(item.highlight, "")} ${
                      item.highlight
                    }`}
                    className="inventoryaccount"
                  />
                </div>
                <div className="yourgroth-information">
                  <h3>
                    {item.heading.replace(item.highlight, "")}{" "}
                    <span>{item.highlight}</span>
                  </h3>
                  <p>{item.desc}</p>
                  <ul className="accounting-futures">
                    {item.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="usefosvgiconmain">
            <div className="box-default pb100 pt100">
              <div className="container">
              <IconSvgAnimation/>
              </div>
            </div>
          </div>

          <div className="rectangle-bg pt100 pb100 mb100">
            <div className="container">
              <div className="titletwo twotabintaly text-center">
                <h2 className="text-white">
                  Invoicing & <span>Accounting</span>
                </h2>
              </div>

              <div className="invoicingaccounting flex">
                {featuresData.map((item, index) => (
                  <div className="accounting-box" key={index}>
                    <img src={item.img} alt={item.title} />
                    <h5>{item.title}</h5>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="container">
            <div className="tallypricebox-main d-flex flex-column flex-sm-row flex-md-row gap50 justify-content-center pb100">
              {pricingData.map((item, index) => (
                <div
                  className={`tallypricebox box-default ${item.colorClass} text-center`}
                  key={index}
                >
                  <div className="tallylogo">
                    <IconTallyPrimelogo />
                  </div>
                  <h4>{item.title}</h4>
                  <p>
                    <span>{item.subtitle}</span>
                  </p>
                  <h1>{item.price}</h1>
                  <p>{item.gst}</p>
                  <div className="buybtn">
                    <HoverButton
                      btnclassname="btn btn-purpal"
                      to={item.btnLink}
                    >
                      <label>
                        Buy Now <IconRightArrow />
                      </label>
                    </HoverButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
